import { Permission, type Role } from '@/models/account-management/Role';
import { createApiResource, listWithOrg, saveWithOrg } from '../adminApi';
import { getJwt, HttpError } from '../common';

const BASE_URL = import.meta.env.VITE_API_URL;
const ROLES_PATH = 'account-management/roles';

export const roleApi = {
    ...createApiResource<Role, string>(ROLES_PATH),
    // Roles follow the VIEWED org — list/create scope to it (a super-admin may pass any org).
    list: (organizationId?: string | null): Promise<Role[]> => listWithOrg<Role>(ROLES_PATH, organizationId),
    save: (item: Role, organizationId?: string | null): Promise<Role | void> => saveWithOrg<Role>(ROLES_PATH, item, organizationId),
    listPermissions: async (): Promise<Permission[]> => {
        const response = await fetch(`${BASE_URL}/account-management/roles/permissions`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${getJwt()}`
            }
        });
        const data = await response.json().catch(() => null);
        if (!response.ok) throw new HttpError(response.status, data);
        return data as Permission[];
    }
};